import { AccordionFieldsFragment } from "src/generated/graphql";
import { highlightBracketedText } from "src/utils/utils";

type NewsComponentProps = {
  content?: AccordionFieldsFragment;
};

const EnterpriseAccordian = ({ content }: NewsComponentProps) => {
  if (!content) {
    return null;
  }

  const { title, descriptionJson, accordionItemsCollection } = content;
  const items = accordionItemsCollection?.items || [];
  const description =
    descriptionJson?.json?.content?.[0]?.content?.[0]?.value ?? "";

  return (
    <div className="results-section">
      <div className="container-fluid custom-spacer-col">
        <div className="results-inner">
          <div className="results-left" style={{ width: "100%" }}>
            <span
              className="highlight-bracket-text"
              dangerouslySetInnerHTML={{
                __html: highlightBracketedText(title ?? "", "bold"),
              }}
              style={{ textAlign: "start" }}
            />

            <div className="results-description enterprise-description">
              <p>{description}</p>
            </div>
          </div>
          <div className="results-right enterprise-right">
            <div className="box-inner-count">
              {items.map((item, index) => {
                return (
                  <div style={{ display: "flex" , alignItems:"flex-start", gap:"8px" }}>
                    <img src={item?.icon?.url ?? ""} alt={item?.icon?.title ?? ""} />
                    <div
                      className="count-value text-start"
                      key={index}
                      style={{ gap: "0px" }}
                    >
                      <h4 className="counter bold" style={{ color: "#fff" ,marginBottom:"0px" }}>
                        {item?.itemText}
                      </h4>
                      <p className="light enterprise-text">
                        {item?.additionalItemText}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseAccordian;
